import { RiRefreshLine } from '@remixicon/react';

import { Button, Text } from '@spotify-internal/encore-web';

import styles from './PlayerError.module.css';

type PlayerErrorProps = {
  message?: string;
  onRetry: () => void;
};

export const PlayerError = ({ message, onRetry }: PlayerErrorProps) => (
  <div className={styles.root}>
    <Text variant="bodySmall" semanticColor="textSubdued">
      Failed to load recording
    </Text>
    {message && (
      <Text variant="bodySmall" semanticColor="textNegative">
        {message}
      </Text>
    )}
    <Button
      type="button"
      variant="tertiary"
      size="small"
      onClick={onRetry}
      data-track-id="button.player"
      data-track-action="retry"
    >
      <RiRefreshLine size={16} aria-hidden />
      Retry
    </Button>
  </div>
);
